/**
 * Single source of truth for V2 media player rollout
 * Supports both localStorage and .env toggling
 * 
 * Enable via:
 * - localStorage: localStorage.setItem('YS_MEDIA_V2', '1'); location.reload();
 * - .env: VITE_MEDIA_V2=1
 */
export function useV2(): boolean {
  // Runtime toggle via localStorage OR .env (both supported)
  const env = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_MEDIA_V2 : undefined;
  const lc = typeof window !== 'undefined' ? window.localStorage?.getItem('YS_MEDIA_V2') : null;
  return lc === '1' || env === '1';
}
